module.exports = __webpack_public_path__ + "static/media/analytics_1.5725cc57.png";